module.exports = new __parcel__URL__("GT_P_1Blau_008_mobile.f76d9dec.json").toString();